import React, {useContext} from 'react';
import MobileBanner from "@/page-components/detail/Banner/mobile_banner";
import PCBanner from "@/page-components/detail/Banner/pc_banner";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import {DetailContext} from "@/context/detailContext";
import styles from './styles.module.less';

const Banner= () => {
  const contextProps = useContext(DetailContext);
  const {data:{title, english_title,intro}} = contextProps;
  return (
    <div className={styles.banner_wrapper}>
      <MobileComponentWrapper>
        <MobileBanner title={title} english_title={english_title} intro={intro}/>
      </MobileComponentWrapper>
      <PcComponentWrapper>
        <PCBanner title={title} english_title={english_title} intro={intro}/>
      </PcComponentWrapper>
    </div>
  )
}
export default Banner;
